import { DOCTORS, IMG } from "@/data/site";
import { DoctorProfile } from "@/components/common/DoctorProfile";
import { AppointmentForm } from "@/components/common/AppointmentForm";
import { Reveal } from "@/components/common/Reveal";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="grain relative overflow-hidden bg-maroon-ink">
        <div className="container-x relative grid items-center gap-10 py-16 md:py-20 lg:grid-cols-2">
          <Reveal>
            <p className="eyebrow text-amber-300">हमारे डॉक्टर · Our Doctors</p>
            <h1 className="font-display mt-4 text-4xl leading-tight text-white sm:text-5xl lg:text-6xl">दो विशेषज्ञ, एक भरोसेमंद टीम</h1>
            <p className="font-en mt-5 max-w-xl text-white/75 md:text-lg">An LVPEI-trained eye surgeon and a DNB general & laparoscopic surgeon — caring for Ballia under one roof.</p>
          </Reveal>
          <Reveal delay={0.15}>
            <img src={IMG.exam} alt="Medicity doctors" className="h-[320px] w-full rounded-[28px] object-cover md:h-[400px]" />
          </Reveal>
        </div>
      </section>
      {DOCTORS.map((d, i) => <DoctorProfile key={d.key} d={d} flip={i % 2 === 1} />)}
      <AppointmentForm />
    </div>
  );
}
